import React, { useEffect } from "react";
import { useDatatableWrapper } from "react-bs-datatable";

/**
 * ScrollLazyLoader progressively increases the rowsPerPage state when the user 
 * scrolls near the bottom of the page, acting as an infinite scroll within 
 * react-bs-datatable.
 */
const ScrollLazyLoader = ({ maxRows = 1000, step = 50 }) => {
  const { rowsPerPageState, onRowsPerPageChange, filteredDataLength } =
    useDatatableWrapper();

  useEffect(() => {
    const handleScroll = (e) => {
      const target = e.target;
      let scrollTop, clientHeight, scrollHeight;

      if (target === document || target === window) {
        scrollTop = window.scrollY || document.documentElement.scrollTop;
        clientHeight = window.innerHeight;
        scrollHeight = document.documentElement.scrollHeight;
      } else {
        scrollTop = target.scrollTop;
        clientHeight = target.clientHeight;
        scrollHeight = target.scrollHeight;
      }

      if (scrollTop + clientHeight >= scrollHeight - 300) {
        if (
          rowsPerPageState < maxRows &&
          rowsPerPageState < filteredDataLength
        ) {
          const nextRows = Math.min(
            rowsPerPageState + step,
            maxRows,
            filteredDataLength
          );
          if (nextRows !== rowsPerPageState) {
            onRowsPerPageChange(nextRows);
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll, true);
    return () => window.removeEventListener("scroll", handleScroll, true);
  }, [rowsPerPageState, onRowsPerPageChange, filteredDataLength, maxRows, step]);

  return null;
};

export default ScrollLazyLoader;
